<div class="phx-tokenize-input-box" [class.phx-tokenize-input-invalid]="!control?.valid && control.touched">
  <phx-tag
    *ngFor="let tag of tags; index as i"
    [phxSuffixIcon]="CrossIcon"
    [disabled]="disabled"
    [phxTagType]="!isValidTag(tag)? 'neutral': 'negative'"
    phxContrast="low"
    phxSize="medium"
    (phxOnClick)="removeTag(i)"
  >
    {{ tagText(tag) }}
  </phx-tag>
  <input 
    [(ngModel)]="newTag" 
    class="phx-tokenize-input-field"
    [placeholder]="phxPlaceholder"
    type="text"
    [disabled]="phxDisabled"
    (blur)="handleBlur()"
    (keydown)="handleKeydown($event)" 
  />
</div>
<label *ngIf="control.errors?.invalidTag && !phxDisabled" class="phx-web-type-body-small phx-tokenize-input-error">
  {{control.errors?.invalidTag}}
</label>
  
